import HttpService from "../../constant/Api";

const API = "v1/contents";

export const getContents = (params) => {
  params.type = "news-client";
  return HttpService.get(API, { params });
};

export const getContent = (id) => {
  return HttpService.get(`${API}/${id}`);
};

export const addUserRate = (id, rate) => {
  return HttpService.post(`${API}/${id}/user-rate`, {
    value: rate,
  });
};
